import { useRoutes } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import EditFormRoute from "../../Component/Forms/EditFormRoute.js"

import AddHelp from "./ManageHelp/Create.js"
import ViewHelp from "./ManageHelp/View.js"
import ProtectedRoute from "../RouteProtect.js"


const RoutesArray = [
    {
        path: "*",
        element: <h1>This is 404</h1>
    },
    {
        path: "",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <ViewHelp />
                </ProtectedRoute>
            )
    },
    {
        path: "/manageHelp",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <ViewHelp />
                </ProtectedRoute>
            )
    },
    {
        path: "/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "/addhelp",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <AddHelp />
            </ProtectedRoute>
        )
    },
   
];


export default function MangeRoutes() {
    return useRoutes(RoutesArray)
};